import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { getIn } from "formik";
import { useState } from "react";

export function InputPassword({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, handleBlur, handleChange }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  size = "small",
  variant = "outlined",
  colorIconButton,
  ...props
}) {
  const [isVisibilityPassword, setVisibilityPassword] = useState(false);
  const handleVisibilityPassword = () => {
    setVisibilityPassword((prev) => !prev);
  };
  return (
    <>
      <TextField
        size={size}
        type={isVisibilityPassword ? `text` : `password`}
        name={field.name}
        label={label}
        variant={variant}
        onBlur={handleBlur}
        onChange={handleChange}
        helperText={getIn(touched, field.name) && getIn(errors, field.name)}
        error={Boolean(getIn(touched, field.name) && getIn(errors, field.name))}
        {...field}
        {...props}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                style={{ color: colorIconButton }}
                onClick={handleVisibilityPassword}
              >
                {isVisibilityPassword ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}
